/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const GroupProgressParams = zod.object({
  today: zod.string().describe("The caller's local date; it picks the week (Monday to Sunday)"),
});

export type GroupProgressParams = zod.input<typeof GroupProgressParams>;
export type GroupProgressParamsOutput = zod.output<typeof GroupProgressParams>;
